import React, { Component } from 'react'

export class PrivacyPolicy extends Component {
  render() {
    return (
      <div>
        <h1>Privacy Policy</h1>
      </div>
    )
  }
}

export default PrivacyPolicy
